import { useEffect, useState } from "react";
import customerService from "../../services/customerService";

const useAddresses = (customerId) => {
    const [addresses, setAddresses] = useState([])
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const getAddresses = async () => {
            setLoading(true);
            customerService
                .GetAddresses(customerId, { pageNumber: 1, pageSize: 100 })
                .then(res => setAddresses(res.values))
                .finally(() => setLoading(false));
        }
        if (customerId) 
            getAddresses();
    }, [customerId])

    const createAddress = (address) => {
        customerService
            .CreateAddress(customerId, address)
            .then(res => setAddresses([...addresses, res]))
            .catch(err => console.error(err.message))
    }

    return {
        addresses,
        loading,
        createAddress
    }
}
export default useAddresses;